export const TOPICS = [
	{
		Topic: ['reactor', !PRODUCTION && 'unstable'].filter(Boolean).join('_'),
		Version: 2,
	}
];
